<div class="date-picker-container" [formGroup]="selectedDate">
	<input
		class="date-picker-input"
		type="date"
		formControlName="date"
		[min]="minDate() ? (minDate() | date: 'yyyy-MM-dd') : null"
		[max]="maxDate() ? (maxDate() | date: 'yyyy-MM-dd') : null"
	/>

	<div class="placeholder-container">
		@if (dateValue()) {
			<i class="icon-x-circle-line clear-btn" (click)="clearSelectedDate()"></i>
		}
		<input
			class="placeholder"
			type="text"
			placeholder="{{dateLabel()}}"
			[value]="dateValue() | date: 'dd-MMM-yyyy'"
			readonly
		>
	</div>
</div>
